<!-- src/views/UserAdd.vue -->
<template>
  <v-container>
    <v-card>
      <v-card-title>
        <v-btn icon="mdi-arrow-left" variant="text" @click="router.back()" class="mr-2"></v-btn>
        Add New User
      </v-card-title>

      <v-card-text>
        <v-form @submit.prevent="handleSubmit" v-model="isFormValid" ref="form">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="formData.email"
                label="Email Address"
                type="email"
                :rules="[
                  v => !!v || 'Email is required',
                  v => /.+@.+\..+/.test(v) || 'Email must be valid',
                  v => v === v.toLowerCase() || 'Email must be lowercase'
                ]"
                hint="This will be used as the username"
                persistent-hint
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="formData.password"
                label="Password"
                type="password"
                :rules="[v => !!v || 'Password is required']"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="formData.firstName"
                label="First Name"
                :rules="[v => !!v || 'First name is required']"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="formData.lastName"
                label="Last Name"
                :rules="[v => !!v || 'Last name is required']"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-select
                v-model="formData.role"
                :items="roles"
                label="Role"
                :rules="[v => !!v || 'Role is required']"
                required
              ></v-select>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :loading="loading"
          :disabled="!isFormValid"
          @click="handleSubmit"
        >
          Save User
        </v-btn>
      </v-card-actions>

      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :timeout="3000"
      >
        {{ snackbar.text }}
      </v-snackbar>
    </v-card>
  </v-container>
</template>

<script setup lang="ts">
import { ref, reactive } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'

const router = useRouter()
const form = ref(null)
const isFormValid = ref(false)
const loading = ref(false)

const roles = ['USER', 'ADMIN']

const formData = reactive({
  email: '',
  password: '',
  firstName: '',
  lastName: '',
  role: 'USER'
})

const snackbar = reactive({
  show: false,
  text: '',
  color: 'success'
})

const handleSubmit = async () => {
  if (!isFormValid.value) return

  // Ensure email is lowercase before submission
  formData.email = formData.email.toLowerCase()

  loading.value = true
  try {
    await axios.post('/api/admin/users', formData)
    snackbar.color = 'success'
    snackbar.text = 'User created successfully'
    snackbar.show = true

    setTimeout(() => {
      router.push({ name: 'users' })
    }, 1500)
  } catch (error) {
    console.error('Error creating user:', error)
    snackbar.color = 'error'
    snackbar.text = error.response?.data?.message || 'Error creating user'
    snackbar.show = true
  } finally {
    loading.value = false
  }
}
</script>
